import React from 'react';

import Img from '@common/Image';
import Link from '@common/Link';
import Heading from '@common/Heading';

const Card = ({ data }) => {
  const {
    link,
    linkCopy,
    title,
    subtitle,
    image,
    date
  } = data;
  return (
    <Link to={link} className={`d-flex flex-column justify-content-between no-hover text-black`}>
      <div className={`d-flex mb-2`}>
        {subtitle && <p className={`fs-12 text-uppercase text-blue`}>{subtitle}</p>}
        {date && <p className={`fs-12 ps-1`}>{`| ${date}`}</p>}
      </div>
      {image &&
        <div className='position-relative' style={{height:300}}>
          <div className='position-absolute' style={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: -1,
            backgroundImage: `url(${image?.file.url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}/>
        </div>
      }
      {title && <Heading type='h4' className={`mt-3`}>{title}</Heading>}
      {linkCopy && <div className={`fw-semibold text-blue d-block mt-xs-1 d-block show-hover`}>{linkCopy}</div>}
    </Link>
  )
}

export default Card
